/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ========================================================================
 */
(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages


            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);


    $(document).ready(function () {
        $("#mobile-nav li a").click(function (event) {
            $(".navbar-collapse").collapse('hide');
        });

        $("#open_header").click(function () {
            var header = $("#open_header span");
            var content = $("#learn_more_content");
            content.slideToggle(500, function () {
                header.text(function () {
                    return content.is(":visible") ? "Less" : "Learn More";
                })
            });
        });
    });

})(jQuery); // Fully reference jQuery after this point.


window.onload = function () {

    /*
     |--------------------------------------------------------------------------
     | Header Navigation Hijack
     |--------------------------------------------------------------------------
     */
    document.body.addEventListener('click', onClick, false);

    var videoElement,
        videoHeight,
        containerProperties = [],
        currentMiddle,
        currentTopOfViewport,
        currentBottomOfViewport;

    /*  |-----------------------------------------------------------
     |   HERO VIDEO CONTROL HANDLE
     |-----------------------------------------------------------
     */

    videoElement = document.getElementsByTagName('video');
    videoHeight = videoElement[0].clientHeight;

    containerProperties = calculateNovusParallax();

    window.addEventListener('focus', function () {
        videoElement[0].play();
    });
    window.addEventListener('blur', function () {
        videoElement[0].pause();
    });

    window.addEventListener('scroll', function (event) {

        stickyTop();


        // Stop the video from playing when not in-focus
        if (window.pageYOffset > videoHeight) {

            videoElement[0].pause();

        } else if (window.pageYOffset < videoHeight) {

            videoElement[0].play();

        }

        currentMiddle = window.pageYOffset + (.5 * innerHeight);
        currentTopOfViewport = window.pageYOffset;
        currentBottomOfViewport = window.pageYOffset + innerHeight;

        for (i = 0, len = containerProperties.length; i < len; i++) {

            var tempUpperLimit = containerProperties[i].upperLimit,
                tempLowerLimit = containerProperties[i].lowerLimit;

            // Need to escape if currentMiddle is outside bounds...
            if (currentBottomOfViewport >= tempUpperLimit &&
                currentTopOfViewport <= tempLowerLimit) {

                var translateY,
                    tempCutPoint = containerProperties[i].cutPoint,
                    tempDistanceAway = (tempCutPoint - currentMiddle),
                    tempOutSpeed = containerProperties[i].out_speed,
                    tempInSpeed = containerProperties[i].in_speed,
                    tempForeground = containerProperties[i].foreground;

                if (currentMiddle >= tempCutPoint) {

                    translateY = 'translateY(' + (tempDistanceAway * tempOutSpeed) + 'px)';

                } else if (currentMiddle <= tempCutPoint) {

                    translateY = 'translateY(' + (-tempDistanceAway * tempInSpeed) + 'px)';

                }

                tempForeground.style['-webkit-transform'] = translateY;
                tempForeground.style['-moz-transform'] = translateY;
                tempForeground.style['-ms-transform'] = translateY;
                tempForeground.style['-o-transform'] = translateY;
                tempForeground.style.transform = translateY;
            }
        }
    });
};

window.onresize = function () {
    containerProperties = calculateNovusParallax();
};

function stickyTop() {

    var wavesBottomLocation = getWavesBottom();
    var navHeight = document.getElementById('main_navigation').offsetHeight;
    var navTop = wavesBottomLocation - navHeight;
    var header = document.getElementById('main_navigation');

    if (window.pageYOffset > navTop) {

        addClass(header, "sticky");
    }
    else {
        removeClass(header, "sticky");
    }
}

function getWavesBottom() {

    var waves = document.getElementById('waves');
    var wavesTop = waves.offsetTop;
    var wavesHeight = waves.offsetHeight;
    return wavesHeight + wavesTop;

}

function calculateNovusParallax() {

    var containers,
        i,
        len,
        containerProperties = [],
        pContainer,
        upperLimit,
        foreground,
        foregroundHeight
    ;


    containers = document.querySelectorAll("[data-type='novus-parallax']");

    // Build the containerProperties array with each instance of novus-parallax so we're not re-calculating each scroll event

    for (i = 0, len = containers.length; i < len; i++) {

        var tempProperties = [];
        pContainer = containers[i];

        // This is the top of the container... should also be accessible (and more robust) via
        // pContainer.getBoundingClientRect().top

        upperLimit = pContainer.offsetParent.offsetTop + pContainer.offsetTop;
        tempProperties.upperLimit = upperLimit;

        // This is the bottom of the container... also should be accessible via
        // pContainer.getBoundingClientRect().bottom

        tempProperties.lowerLimit = upperLimit + pContainer.clientHeight;
        foreground = pContainer.querySelector("#foreground");
        tempProperties.foreground = foreground;
        foregroundHeight = foreground.getAttribute('data-natural-height');
        tempProperties.foregroundHeight = foregroundHeight;
        tempProperties.in_speed = foreground.getAttribute('data-in-speed');
        tempProperties.out_speed = foreground.getAttribute('data-out-speed');
        tempProperties.cutPoint = upperLimit + (.5 * foregroundHeight);
        containerProperties[i] = tempProperties;

    }

    return containerProperties;

}


/*
 |--------------------------------------------------------------------------
 |  Navigation Support Functions
 |--------------------------------------------------------------------------
 */

function hasClass(el, className) {
    if (el.classList)
        return el.classList.contains(className)
    else
        return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
}

function addClass(el, className) {
    if (el.classList)
        el.classList.add(className)
    else if (!hasClass(el, className)) el.className += " " + className
}

function removeClass(el, className) {
    if (el.classList)
        el.classList.remove(className)
    else if (hasClass(el, className)) {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
        el.className = el.className.replace(reg, ' ')
    }
}

function onClick(e) {
    if (!isInPageLink(e.target))
        return;

    e.stopPropagation();
    e.preventDefault();

    jump(e.target.hash, {
        duration: '2000',
        offset: -100
    });
}

function isInPageLink(n) {
    return n.tagName.toLowerCase() === 'a'
        && n.hash.length > 0
        && stripHash(n.href) === pageUrl
        ;
}

var pageUrl = location.hash
    ? stripHash(location.href)
    : location.href
;

function stripHash(url) {
    return url.slice(0, url.lastIndexOf('#'));
}


function jump(target, options) {
    var start = window.pageYOffset;

    var opt = {
        duration: options.duration,
        offset: options.offset || 0,
        callback: options.callback,
        easing: options.easing || easeInOutQuad
    };

    var distance = typeof target === 'string' ?
        opt.offset + document.querySelector(target).getBoundingClientRect().top :
        target
    ;

    var duration = typeof opt.duration === 'function'
        ? opt.duration(distance)
        : opt.duration
    ;

    var timeStart = null,
        timeElapsed
    ;

    requestAnimationFrame(function (time) {
        timeStart = time;
        loop(time);
    });

    function loop(time) {
        timeElapsed = time - timeStart;

        window.scrollTo(0, opt.easing(timeElapsed, start, distance, duration));

        if (timeElapsed < duration)
            requestAnimationFrame(loop)
        else
            end();
    }

    function end() {
        window.scrollTo(0, start + distance);

        typeof opt.callback === 'function' && opt.callback();
        timeStart = null;
    }

    // ...

}

function easeInOutQuad(t, b, c, d) {
    t /= d / 2
    if (t < 1) return c / 2 * t * t + b
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
}
